import { KeyValue } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { utcToZonedTime } from 'date-fns-tz';
import { ContractService } from 'src/app/services/contract.service';
import { MapGoogleService } from 'src/app/services/map-google.service';
import { MapService } from 'src/app/services/map.service';
import { TaskService } from 'src/app/services/task.service';
import { TeamService } from 'src/app/services/team.service';
import { VehicleService } from 'src/app/services/vehicles.service';
import { ActionEnum, ComplementInformationEnum, ComplementInformationSignEnum, SignalingTypeEnum, TaskTypeEnum, VerticalSignalizationTypeEnum, WarrantyStatusEnum } from 'src/enumerators';
import { Member, Task, Team, Vehicle } from 'src/models';
@Component({
  selector: 'app-sidebar-task',
  templateUrl: './sidebar-task.component.html',
  styleUrls: ['./sidebar-task.component.css', '../sidebar-map.component.css', '../../../../map-page/map-page.component.css']
})
export class SidebarTaskComponent implements OnInit, OnChanges {

  complementInformationTypeEnum = ComplementInformationEnum;
  signTypeEnum = SignalingTypeEnum;
  signType = '';
  warrantyTypeEnum = WarrantyStatusEnum;
  warrantyType = '';
  retroreflection = ActionEnum.Retroreflection;
  taskActivities: any // quantitativo das atividades
  taskActivitiesProgress: boolean[] = [] // Progresso em booleano das atividades
  activitySigns: any[] = [] // sinalizações da atividade
  members: Member[] = [] // membro para dar find() com lider de equipe

  @Input() selectedTask: Task
  @Output() changeIdEmitter = new EventEmitter<string>(); // Emite os valores para o componente pai;

  constructor(
    private _taskService: TaskService,
    private _teamService: TeamService,
    private _vehicleService: VehicleService,
    private _contractService: ContractService,
    private _mapGoogleService: MapGoogleService,
    private _mapService: MapService,

  ) { }

  ngOnInit(): void {
    this.getTask();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.selectedTask?.currentValue != changes?.selectedTask?.previousValue) {
      this.getTask();
    }
  }

  closeSideBar() {
    this._mapGoogleService.toggleSideBar(false);
    this._mapService.openSideBar(false);
  }

  getTask() {
    this._taskService.getTaskById(this.selectedTask.id).subscribe((res: Task) => {
      this.selectedTask = res;
      const executionDate = utcToZonedTime(this.selectedTask.executionDate, 'UTC');
      this.selectedTask.executionDate = executionDate;
      this._taskService.getTaskProgress().subscribe((progressList: Array<any>) => {
        this.taskActivities = progressList.find((task) => task.taskId == res.id);
        this.taskActivitiesProgress = []
        for (let index = 0; index < this.taskActivities?.activities; index++) {
          this.taskActivitiesProgress.push(index < this.taskActivities?.completedActivities);
        }
        this.getActivities(res)
        this.getTeamAndVehicle(this.selectedTask)
      });
    })
  }

  // Seta time e veículo da tarefa
  getTeamAndVehicle(task: Task) {
    if (task.teamId) {
      this._teamService.getTeam(task.teamId).subscribe(
        (res: Team) => {
          task.team = res
          if (!this.members.length) {
            this._contractService.listAllWorkspaceUsers().subscribe(
              (res: { members: Member[] }) => {
                this.members = res.members
                task.team['user'] = this.members.find(m => m.id == task.team.leaderMemberId).user
              }
            )
          } else {
            task.team['user'] = this.members.find(m => m.id == task.team.leaderMemberId).user
          }
        }
      )
    }
    if (task.vehicleIds?.length) {
      // Carrega todos os veículos da tarefa; o sidebar continua mostrando o
      // primeiro, mas a lista completa fica disponível em task.vehicles.
      Promise.all(
        task.vehicleIds.map((id) => this._vehicleService.getVehicle(id).toPromise() as Promise<Vehicle>),
      ).then((res) => {
        task.vehicles = res.filter((v): v is Vehicle => !!v);
      });
    }

  }

  // Anula os valores persistidos no sidebar
  changeSelectedId(value) {
    this.selectedTask = value;
    this.changeIdEmitter.emit(value);

  }
  // Verifica se na lista de objetos tem algum objeto com certo ID e retorna o name dele;
  isValueKeyId(value, list): string {
    let name = '';
    list.some((element) => {
      if (element.id == value) {
        name = element.name;
      }
    });
    return name;
  }

  // Retorna qual é o tipo da informação complementar sabendo qual é o tipo da placa WARNING/REGULATION
  complementType(sign): ComplementInformationSignEnum {
    if (sign.complementInformationType == ComplementInformationEnum.Additional) {
      if (sign.verticalType == VerticalSignalizationTypeEnum.Warning) {
        return ComplementInformationSignEnum.AdditionalWarning;
      } else {
        return ComplementInformationSignEnum.AdditionalRegulation;
      }
    } else {
      if (sign.verticalType == VerticalSignalizationTypeEnum.Warning) {
        return ComplementInformationSignEnum.IncorporatedWarning;
      } else {
        return ComplementInformationSignEnum.IncorporatedRegulation;
      }
    }
  }

  // Preserva ordem do ngFor | keyvalue
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  };

  openAccordionGroup(item) {
    item.isAccOpen = !item.isAccOpen;
  }

  // Seta o icone da tarefa
  setTaskIcon(taskType): Object {
    return {
      'fa-square-plus': taskType == TaskTypeEnum.Implantation,
      'fa-square-x': taskType == TaskTypeEnum.Removal,
      'fa-brush': taskType == TaskTypeEnum.Maintenance,
      'fa-arrow-down-to-bracket': taskType == TaskTypeEnum.Cataloging,
      'fa-arrows-cross': taskType == TaskTypeEnum.Replacement,
    };
  }


  // Popula as atividades da tarefa
  getActivities(task: Task) {
    this.activitySigns = []
    task.trafficSignTaskActivities.forEach(task => {
      this.activitySigns.push({
        signName: task.verticalCode,
        progress: `${task.quantityRegistered} / ${task.quantity}`
      })
    })
    task.horizontalSignalingTaskActivities.forEach(task => {
      this.activitySigns.push({
        signName: task.horizontalCode,
        progress: `${task.quantityRegistered} / ${task.quantity}`
      })
    })
    task.deviceSignalingTaskActivities.forEach(task => {
      this.activitySigns.push({
        signName: task.deviceCode,
        progress: `-`
      })
    })
    task.maintenanceTrafficSignTaskActivities.forEach(task => {
      this.activitySigns.push({
        signName: task.sign.verticalCode,
        progress: `-`
      })
    })
    task.maintenanceHorizontalSignalingTaskActivities.forEach(task => {
      this.activitySigns.push({
        signName: task.sign.horizontalCode,
        progress: `-`
      })
    })
    task.maintenanceDeviceSignalingTaskActivities.forEach(task => {
      this.activitySigns.push({
        signName: task.sign.deviceCode,
        progress: `-`
      })
    })
  }

}
